import {useQuery} from "react-query"
import {PathTrackingApi} from "api/path-tracking.api"
import {useRootStore} from "store/useRootStore"
import dayjs from "dayjs";
import {toPathTracking} from "dto/path-tracking/path-tracking"

// export const useFindByEuiAndDate = (eui: string, date: Date, page: number, size: 100) => {
export const useFindPathTrackingByEuiAndDate = () => {
    const {dashboardStore: {selectedDevice, pathTrackingStore: {searchDate, pageSize, page}}} = useRootStore()
    const eui = selectedDevice?.communicationDevice.eui || undefined
    const date = dayjs(searchDate).format("YYYY-MM-DD")
    return useQuery(["findPathTrackingByEuiAndDate", eui, date, page, pageSize], async () => {
        const response = await PathTrackingApi.findByEuiAndDate(eui || "", date || "", page, pageSize)
        return {
            ...response.data.body,
            content: (response.data.body?.content || []).map(toPathTracking)
        }
    }, {
        enabled: !!(eui && date),
        refetchIntervalInBackground: true,
        refetchInterval: 5 * 1000,
        refetchOnWindowFocus: true,
        cacheTime: 0
    })
}

export const useFindPathTrackingAll = () => {
    const {adminStore: {pathTrackingStore: {keyword, page, size, showOnlyEmergency}}} = useRootStore()
    return useQuery(["findPathTrackingAll", page, size, keyword, showOnlyEmergency], async () => {
        console.log("call ", keyword)
        if (keyword) {
            if(showOnlyEmergency) {
                const response = await PathTrackingApi.findAllByEuiAndEmergency(keyword, page, size)
                return {
                    ...response.data.body,
                    content: (response.data.body?.content || []).map(toPathTracking)
                }
            }
            const response = await PathTrackingApi.findAllByEuiContains(keyword, page, size)
            return {
                ...response.data.body,
                content: (response.data.body?.content || []).map(toPathTracking)
            }
        }

        if(showOnlyEmergency) {
            const response = await PathTrackingApi.findAllByEmergency(page, size)
            return {
                ...response.data.body,
                content: (response.data.body?.content || []).map(toPathTracking)
            }
        }
        const response = await PathTrackingApi.findAll(page, size)
        return {
            ...response.data.body,
            content: (response.data.body?.content || []).map(toPathTracking)
        }
    }, {
        cacheTime: 0
    })
}

export const useFindImpactHistoryByEui = () => {
    const {dashboardStore: {selectedDevice, impactHistoryStore: {pageSize, page}}} = useRootStore()
    const eui = selectedDevice?.communicationDevice.eui || undefined
    return useQuery(["findImpactStatusByEuiAndDate", eui, page, pageSize], async () => {
        const response = await PathTrackingApi.findByImpactByEui(eui || "", page, pageSize)
        return {
            ...response.data.body,
            content: (response.data.body?.content || []).map(toPathTracking)
        }
    }, {
        enabled: !!(eui)
    })
}

export const useFindRecentLogCounter = () => {
    return useQuery(["findRecentLogCounter"], async () => {
        const response = await PathTrackingApi.findRecentLogCounter(10)
        return response.data.body
    }, {
        refetchInterval: 30 * 1000,
    })
}